import React from 'react'

// Instruction page for API documentation
const apiExample = `   
 const formData = new FormData()
          formData.append('file', data, {
            filename: qfname,
            contentType: 'image/png'
          })

await axios.put(
            https://api.geraniumpos.com/api/uploads?qfname=&cid=&qrid=&barcode=,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                ...formData.getHeaders(),
                Authorization: Bearer YOUR_API_KEY // API key sent in header
              }
            }
          )`

function ApiDocument() {
  return (
    <div style={{ padding: '1rem', maxWidth: 800, margin: '0 auto' }}>
      <h2>API Connection Instructions</h2>
      <p>To connect to our API, follow these steps:</p>
      <ol>
        <li>Obtain your API key from your account dashboard.</li>
        <li>
          Use the endpoint <code>https://api.geraniumpos.com/api/uploads</code>{' '}
          for requests.
        </li>
        <li>
          The variable <code>qrid</code> is the result of scanning the user qr
          code.
        </li>
        <li>
          The variable <code>cid</code> is your customer id.
        </li>

        <li>
          The variable <code>barcode</code> is the barcode of the transmitted
          receipt.
        </li>
        <li>
          The variable <code>qfname</code> is the name of the file being
          uploaded. This is part of the header as{' '}
          <code>Content-Type: multipart/form-data</code>. For this purpose the{' '}
          <code>npm module form-data</code> is used in Javascript.
        </li>
        <li>
          Include your API key in the <code>Authorization</code> header bearer
          token as shown below.
        </li>
      </ol>
      <h3>Example Request</h3>
      <pre
        style={{
          background: '#f4f4f4',
          padding: '1rem',
          borderRadius: '5px',
          overflowX: 'auto'
        }}
      >
        <code>{apiExample}</code>
      </pre>
      <p>
        Replace <code>YOUR_API_KEY</code> with your actual API key.
      </p>
    </div>
  )
}

export default ApiDocument
